import type { CanonicalWork } from "./generated/contracts";
import type { HomeShelf } from "./api";

// Preserve the published ordering within each selection while mixing formats.
// Never repeat a work that appears in more than one editorial shelf.
export function selectFeatured(shelves: HomeShelf[], limit = 12): CanonicalWork[] {
  const groups = new Map<string, CanonicalWork[]>();
  const seen = new Set<string>();
  for (const shelf of shelves) for (const work of shelf.items) {
    if (seen.has(work.id)) continue;
    seen.add(work.id);
    const group = work.kind === "music" ? "music"
      : work.kind === "audio-teaching" ? "teaching"
      : work.kind === "video" ? "video"
      : work.kind === "verse" ? "verse" : "reading";
    if (!groups.has(group)) groups.set(group, []);
    groups.get(group)!.push(work);
  }
  const result: CanonicalWork[] = [];
  while (result.length < limit) {
    let added = false;
    for (const key of ["teaching", "reading", "music", "video", "verse"]) {
      const group = groups.get(key) || [];
      const work = group.shift();
      if (work) { result.push(work); added = true; }
      if (result.length === limit) break;
    }
    if (!added) break;
  }
  return result;
}
